export interface StateCities {
  state: string;
  name: string;
  cities: string[];
}

export const BRAZIL_STATES_LIST = [
  { uf: "AC", name: "Acre" },
  { uf: "AL", name: "Alagoas" },
  { uf: "AM", name: "Amazonas" },
  { uf: "AP", name: "Amapá" },
  { uf: "BA", name: "Bahia" },
  { uf: "CE", name: "Ceará" },
  { uf: "DF", name: "Distrito Federal" },
  { uf: "ES", name: "Espírito Santo" },
  { uf: "GO", name: "Goiás" },
  { uf: "MA", name: "Maranhão" },
  { uf: "MG", name: "Minas Gerais" },
  { uf: "MS", name: "Mato Grosso do Sul" },
  { uf: "MT", name: "Mato Grosso" },
  { uf: "PA", name: "Pará" },
  { uf: "PB", name: "Paraíba" },
  { uf: "PE", name: "Pernambuco" },
  { uf: "PI", name: "Piauí" },
  { uf: "PR", name: "Paraná" },
  { uf: "RJ", name: "Rio de Janeiro" },
  { uf: "RN", name: "Rio Grande do Norte" },
  { uf: "RO", name: "Rondônia" },
  { uf: "RR", name: "Roraima" },
  { uf: "RS", name: "Rio Grande do Sul" },
  { uf: "SC", name: "Santa Catarina" },
  { uf: "SE", name: "Sergipe" },
  { uf: "SP", name: "São Paulo" },
  { uf: "TO", name: "Tocantins" },
];

export const BRAZIL_CITIES_BY_STATE: Record<string, string[]> = {
  SP: [
    "São Paulo", "Campinas", "Santos", "Ribeirão Preto", "Guarulhos", "São José dos Campos",
    "Santo André", "São Bernardo do Campo", "Osasco", "Sorocaba", "Mogi das Cruzes", "Jundiaí",
    "Piracicaba", "Bauru", "São José do Rio Preto", "Francas", "Taubaté", "Indaiatuba",
    "Praia Grande", "Guarujá", "Caraguatatuba", "Ubatuba", "São Sebastião", "Bertioga",
    "Araraquara", "Presidente Prudente", "Marília", "Limeira", "Americana", "Barueri",
    "Cotia", "Itu", "Salto", "Atibaia", "Bragança Paulista", "São Caetano do Sul", "Diadema",
    "Itapevi", "Suzano", "Jacareí", "Hortolândia", "Valinhos", "Vinhedo", "Botucatu", "Catanduva"
  ],
  RJ: [
    "Rio de Janeiro", "Niterói", "Copacabana", "Barra da Tijuca", "Duque de Caxias", "Nova Iguaçu",
    "São Gonçalo", "Petrópolis", "Volta Redonda", "Macaé", "Cabo Frio", "Búzios",
    "Angra dos Reis", "Paraty", "Teresópolis", "Campos dos Goytacazes", "Resende",
    "Maricá", "Itaboraí", "Nova Friburgo", "Arraial do Cabo", "Nilópolis", "Belford Roxo"
  ],
  MG: [
    "Belo Horizonte", "Uberlândia", "Juiz de Fora", "Montes Claros", "Contagem", "Betim",
    "Uberaba", "Governador Valadares", "Ipatinga", "Sete Lagoas", "Divinópolis", "Poços de Caldas",
    "Patos de Minas", "Pouso Alegre", "Varginha", "Araguari", "Passos", "Nova Lima", "Conselheiro Lafaiete"
  ],
  PR: [
    "Curitiba", "Londrina", "Maringá", "Ponta Grossa", "Cascavel", "Foz do Iguaçu",
    "São José dos Pinhais", "Guaratuba", "Matinhos", "Paranaguá", "Toledo", "Campo Mourão",
    "Umuarama", "Apucarana", "Arapongas", "Guarapuava", "Castro"
  ],
  SC: [
    "Florianópolis", "Joinville", "Blumenau", "Balneário Camboriú", "Chapecó", "Criciúma",
    "Itajaí", "Jaraguá do Sul", "Lages", "Palhoça", "São José", "Tubaráo", "Brusque",
    "Itapema", "Navegantes", "São Francisco do Sul", "Imbituba", "Garopaba"
  ],
  RS: [
    "Porto Alegre", "Caxias do Sul", "Pelotas", "Canoas", "Santa Maria", "Gravataí",
    "Viamão", "Novo Hamburgo", "São Leopoldo", "Rio Grande", "Passo Fundo", "Bento Gonçalves",
    "Gramado", "Canela", "Capão da Canoa", "Torres", "Erechim", "Santa Cruz do Sul"
  ],
  BA: [
    "Salvador", "Feira de Santana", "Vitória da Conquista", "Camaçari", "Juazeiro", "Itabuna",
    "Ilhéus", "Lauro de Freitas", "Porto Seguro", "Jequié", "Barreiras", "Eunápolis",
    "Arraial d'Ajuda", "Trancoso", "Praia do Forte", "Valença", "Texeira de Freitas"
  ],
  PE: [
    "Recife", "Jaboatão dos Guararapes", "Olinda", "Caruaru", "Petrolina", "Paulista",
    "Cabo de Santo Agostinho", "Camaragibe", "Garanhuns", "Ipojuca (Porto de Galinhas)",
    "Victoria de Santo Antão", "Fernando de Noronha"
  ],
  CE: [
    "Fortaleza", "Caucaia", "Juazeiro do Norte", "Maracanaú", "Sobral", "Crato",
    "Itapipoca", "Maranguape", "Iguatu", "Aquiraz", "Cumbuco", "Jericóacoara", "Canoa Quebrada"
  ],
  GO: [
    "Goiânia", "Aparecida de Goiânia", "Anápolis", "Rio Verde", "Luziânia", "Águas Lindas de Goiás",
    "Valparaíso de Goiás", "Trindade", "Formosa", "Itumbiara", "Caldas Novas", "Pirenópolis"
  ],
  DF: [
    "Brasília", "Taguatinga", "Ceilândia", "Águas Claras", "Samambaia", "Plano Piloto",
    "Gama", "Sudoeste/Octogonal", "Guará", "Sobradinho", "Vicente Pires", "Lago Sul", "Lago Norte"
  ],
  ES: [
    "Vitória", "Vila Velha", "Serra", "Cariacica", "Cachoeiro de Itapemirim", "Linhares",
    "São Mateus", "Guarapari", "Colatina", "Aracruz", "Anchieta", "Domingos Martins"
  ],
  PA: [
    "Belém", "Ananindeua", "Santarém", "Marabá", "Parauapebas", "Castanhal",
    "Abaetetuba", "Cametá", "Altamira", "Bragança", "Salinópolis"
  ],
  MA: [
    "São Luís", "Imperatriz", "São José de Ribamar", "Timon", "Caxias", "Codó",
    "Paço do Lumiar", "Açailândia", "Bacabal", "Barreirinhas (Lençóis Maranhenses)"
  ],
  AM: [
    "Manaus", "Parintins", "Itacoatiara", "Manacapuru", "Coari", "Tefé", "Tabatinga"
  ],
  MT: [
    "Cuiabá", "Várzea Grande", "Rondonópolis", "Sinop", "Tangará da Serra", "Cáceres",
    "Sorriso", "Lucas do Rio Verde", "Primavera do Leste", "Barra do Garças"
  ],
  MS: [
    "Campo Grande", "Dourados", "Três Lagoas", "Corumbá", "Ponta Porã", "Naviraí",
    "Sidrolândia", "Nova Andradina", "Bonito"
  ],
  PB: [
    "João Pessoa", "Campina Grande", "Santa Rita", "Patos", "Bayeux", "Sousa", "Cajazeiras", "Cabedelo"
  ],
  RN: [
    "Natal", "Mossoró", "Parnamirim", "São Gonçalo do Amarante", "Macaíba", "Ceará-Mirim", "Pipa (Tibau do Sul)"
  ],
  AL: [
    "Maceió", "Arapiraca", "Rio Largo", "Palmeira dos Índios", "União dos Palmares", "Penedo", "Maragogi"
  ],
  SE: [
    "Aracaju", "Nossa Senhora do Socorro", "Lagarto", "Itabaiana", "São Cristóvão", "Estância"
  ],
  PI: [
    "Teresina", "Parnaíba", "Picos", "Piripiri", "Floriano", "Campo Maior", "Luís Correia"
  ],
  RO: [
    "Porto Velho", "Ji-Paraná", "Ariquemes", "Vilhena", "Cacoal", "Rolim de Moura"
  ],
  TO: [
    "Palmas", "Araguaína", "Gurupi", "Porto Nacional", "Paraíso do Tocantins"
  ],
  AP: [
    "Macapá", "Santana", "Laranjal do Jari", "Oiapoque"
  ],
  AC: [
    "Rio Branco", "Cruzeiro do Sul", "Sena Madureira", "Tarauacá"
  ],
  RR: [
    "Boa Vista", "Rorainópolis", "Caracaraí"
  ]
};

export function getCitiesForState(uf: string, searchTerm: string = ""): string[] {
  const ufUpper = (uf || "").toUpperCase().trim();
  const cities = BRAZIL_CITIES_BY_STATE[ufUpper] || [];
  
  if (!searchTerm.trim()) {
    return cities;
  }
  
  const query = searchTerm.toLowerCase().trim();
  return cities.filter((c) => c.toLowerCase().includes(query));
}

export function searchAllBrazilCities(searchTerm: string, ufFilter?: string): { city: string; state: string }[] {
  const results: { city: string; state: string }[] = [];
  const query = searchTerm.toLowerCase().trim();
  
  if (!query && !ufFilter) return [];

  const statesToSearch = ufFilter ? [ufFilter.toUpperCase()] : Object.keys(BRAZIL_CITIES_BY_STATE);

  for (const uf of statesToSearch) {
    const list = BRAZIL_CITIES_BY_STATE[uf] || [];
    for (const city of list) {
      if (!query || city.toLowerCase().includes(query)) {
        results.push({ city, state: uf });
        if (results.length >= 25) break; // limite para performance
      }
    }
    if (results.length >= 25) break;
  }

  return results;
}
